export default function WelcomeHeader() {
  return (
    <div className="welcomeHeaderContainer">
      <h2 className="welcomeHeader">
        Get SMS Notifications from Averhealth when you&apos;re scheduled for testing.
      </h2>
    </div>
  );
}
